<template>
  <section>
    <!-- SNACKBAR -->
    <v-snackbar
      v-model="snackbar.show"
      :timeout="10000"
      multi-line
      left
      top
      :color="snackbar.color"
    >
      {{ snackbar.text }}
      <v-btn
        flat
        @click="snackbar.show = false"
      >
        Close
      </v-btn>
    </v-snackbar>

      <div class="action--create-basic">
        <v-alert
          :value="err"
          type="error"
          v-if="err"
        >
          {{ err.graphQLErrors.length > 0 ? err.graphQLErrors[0].data.message : err.message }}
        </v-alert>
        <v-card class="action--create-card">
          <v-form v-model="valid" @submit="createAction">
            <p>CREATE ACTION</p>
            <div class="action--create-pd">
              <div class="action--create-grid-2">
                <div>
                  <v-text-field label="Name" v-model="form.name" :rules="nameRules" />
                </div>
                <div>
                <v-autocomplete
                  :loading="loading"
                  :items="resources"
                  item-text="name"
                  flat
                  label="RESOURCE"
                  :rules="actionRules"
                  v-model="form.resource"
                  :search-input.sync="search"
                  clearable
                  persistent-hint
                  allow-overflow
                  return-object
                />
                </div>
              </div>
            </div>

            <div>
              <v-btn color="primary" large block depressed :disabled="!valid" type="submit">Save</v-btn>
            </div>
          </v-form>
        </v-card>
      </div>
  </section>
</template>

<script>
import { coreClient } from "../../../apollo";
import gql from "graphql-tag";
export default {
  name: "CreateAction",
  data() {
    return {
      err: "",
      snackbar: {
        show: false,
        color: "",
        text: ""
      },
      resources: [],
      form: {
        name: "",
        resource: ""
      },
      valid: false,
      search: "",
      loading: false,
      actionRules: [v => !!v || "The resource is required."],
      nameRules: [
        v => !!v || "The name is required.",
        v => v.length > 2 || "The name must be atleast 2 characters."
      ]
    };
  },
  watch: {
    async search(v) {
      if (!v) {
        this.form.resource = "";
        await this.getResources();
        return;
      }

      this.loading = true;
      v && v !== this.form.resource && (await this.getResources({ name: v }));
      this.loading = false;
    }
  },
  methods: {
    async getResources(variables = {}) {
      try {
        const { data } = await coreClient.query({
          query: gql`
            query Resources($name: String, $page: Int) {
              Resources(name: $name, page: $page) {
                total
                pages
                page
                docs {
                  id
                  name
                }
              }
            }
          `,
          variables
        });
        this.resources = data.Resources.docs;
      } catch (err) {
        this.snackbar = {
          text:
            err.graphQLErrors.length > 0
              ? err.graphQLErrors[0].data.message
              : err.message,
          show: true,
          color: "error"
        };
        this.err = err;
      }
    },
    async createAction(e) {
      e.preventDefault();
      try {
        const { data } = await coreClient.mutate({
          mutation: gql`
            mutation createAction($name: String!, $resource: String!) {
              createAction(name: $name, resource: $resource) {
                id
              }
            }
          `,
          variables: { ...this.form, resource: this.form.resource.id }
        });

        const { createAction } = data;

        this.snackbar = {
          show: true,
          color: "success",
          text: "The Action was created."
        };

        setTimeout(() => {
          this.$router.push("/authentication/action/" + createAction.id);
        }, 500);
      } catch (err) {
        this.snackbar = {
          text:
            err.graphQLErrors.length > 0
              ? err.graphQLErrors[0].data.message
              : err.message,
          show: true,
          color: "error"
        };

        this.err = err;
      }
    }
  },
  async mounted() {
    await this.getResources();
  }
};
</script>

<style lang="stylus" scoped>
@import '../../../assets/stylus/Action_create.styl';
</style>
